<template>
  <div class="error-div">
    <span class="error-span">{{ $t('mainComponent.errorPage') }}</span>
  </div>
</template>

<script>
export default {
  name: 'ErrorContainer',
};
</script>

<style scoped>
  .error-div{
    display: grid;
    place-items: center;
    padding: 10px;
    background-color: #FF5252;
  }

  .error-span {
    color: white;
    font-weight: bold;
    font-size: large;
  }
</style>
